import { useUnit } from 'effector-react';
import { useEffect, type ReactNode } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { $themeName, $effectiveTokens, themesFetchAll } from '@/model/theme';
import { GlobalStyle } from './GlobalStyle';
import { composeTheme } from './index';

export const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const [name, tokens] = useUnit([$themeName, $effectiveTokens]);

  useEffect(() => {
    themesFetchAll();
  }, []);

  const theme = composeTheme(name, tokens[name]);

  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyle />
      {children}
    </StyledThemeProvider>
  );
};
